/**Component for CSS shooting star animations. */
const ShootingStars = () => {
  return (
    <section id="shooting-stars">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </section>
  );
};

export default ShootingStars;
